export const SET_WORK_ORDER_DETAIL = 'SET_WORK_ORDER_DETAIL'
export const SET_STICKY_DIV_HEIGHT = 'SET_STICKY_DIV_HEIGHT'
